import type { Routes } from "@angular/router";
import { UserFormFinalize } from "./user-form-finalize/user-form-finalize";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LayoutService } from "../../services/layout.service";

export const viewsRoutes: Routes = [
  {
    path: 'user/:code',
    loadComponent: () => UserFormFinalize,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Finalizar cadastro`;
    }
  }
];
